@if (isRowContext) {
  @for (command of commands; track command) {
    @if (command.isVisible) {
      <button class="tt-margin--left" igxButton="icon" igxRipple [title]="command.label" (click)="command.action()">
        <igx-icon>{{command.icon}}</igx-icon>
      </button>
    }
  }
  @if (menuCommands) {
    <div fxLayout="row" class="tt-margin--left">
      <forge-icon-button dense (click)="overflowMenu($event)">
        <forge-icon name="more_vert"></forge-icon>
      </forge-icon-button>
    </div>
  }
}

<forge-popover #overFlowMenu placement="bottom-end">
  <forge-list dense="true">
    @for (command of menuCommands; track command) {
      <forge-list-item>
        <button type="button" (click)="performCommand(command, $event)" [disabled]="!command.isEnabled" [hidden]="!command.isVisible">
          <div style="color: var(--forge-theme-text-high);" class="forge-menu-expansion--child" fxLayout="row" fxLayoutAlign="space-between center">
            {{command.label}}
          </div>
        </button>
      </forge-list-item>
    }
  </forge-list>
</forge-popover>
